import createValidator from "class-validator-formik-lkc";
import { ClassType } from "../types/ClassType";

export function validateSyncClass(c: ClassType, data: object) {
  const validate = createValidator(c);
  return validate(data);
}
